/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import TransactionItemLayout from './TransactionItemLayout';

const CardTransactionsContainer = ({ date, data, PAN, ...props }) => {
  const handleTransactionDetails = (tx) => {
    tx.PAN = PAN;
    props.setDetails(tx);
    props.showDetails();
  };

  return (
    <div className="mt-3 px-0 card-transaction-group-container">
      <div className="card-transaction-group-container-title row mx-0">
        <h6 className="text-center text-shadow text-f6 mb-0">{date}</h6>
      </div>
      {data.map((tx) => (
        <TransactionItemLayout
          key={`${tx.index}-${tx.id}`}
          tx={tx}
          onDetailsClick={handleTransactionDetails}
        />
      ))}
    </div>
  );
};

export default CardTransactionsContainer;

CardTransactionsContainer.propTypes = {
  date: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  showDetails: PropTypes.func.isRequired,
  setDetails: PropTypes.func.isRequired,
  PAN: PropTypes.string.isRequired,
};
